import React from 'react';
import './style.scss';
import {trackEvent} from '../../../utils/tracking.js';
import PropTypes from 'prop-types';

const Thumbnail = ({src, srcSet, cardType, cardSize, shouldLoad}) => (
    <div className="thumbnail-wrapper">
        {shouldLoad && <img src={src} srcSet={srcSet} className="gig-thumbnail" onClick={() => trackEvent('thumbnail', cardType, cardSize)}/>}
    </div>
);

Thumbnail.propTypes = {
    src: PropTypes.string,
    cardType: PropTypes.string
};

export default Thumbnail;



// WEBPACK FOOTER //
// ./src/shared/media/thumbnail/index.js